import { useContext } from 'react';

import { SelectionListContext } from '../SelectionListProvider';

export const useSelectionListState = () => {
  const context = useContext(SelectionListContext);

  if (!context) {
    throw new Error(
      'useSelectionListContext must be used within a SelectionListProvider'
    );
  }
  const {
    state: { selectionLists },
    isLoading,
  } = context;

  return { selectionLists, isSelectionListsLoading: isLoading };
};
